// Angular
import { ChangeDetectorRef, Component, Inject, OnInit, ViewRef } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { NhapQuyTrinhDuyetService } from '../../quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';

@Component({
  	selector: 'kt-bom-department-dropdown',
  	templateUrl: './bom-department-dropdown.component.html'
})
export class BOMDeparmentDropdownComponent implements OnInit {
	// Các thuộc tính công khai
	isLoading: boolean = false;
	department: string = "";
	division: string = "";
	originalDepartment: any[] = [];

	// Thuộc tính dropdown
	optionDepartment: any[] = [];
	sltUsingDepartment: string = "";
	ftrUsingDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	usingDepartmentFtrCtrl: string = '';
	sltUsingDivision: string = "";
	ftrUsingDivision: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	usingDivisionFtrCtrl: string = '';
	optionsDivision:  any[] = [];

	constructor(
		public dialogRef: MatDialogRef<BOMDeparmentDropdownComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private changeDetectorRef: ChangeDetectorRef,
		private _dynamicSequence: NhapQuyTrinhDuyetService,
		private tokenStorage: TokenStorage,
	) {}

	ngOnInit(): void {
		this.onLoadDepartment();
	}

	// Đóng hộp thoại mà không có kết quả
	onCancel(): void {
		this.dialogRef.close();
	}

	// Đóng hộp thoại với kết quả là true
	onConfirm(): void {
		this.isLoading = true;
		let myDepartment: number = 0;
		this.tokenStorage.getCoCauId().subscribe((a) => { myDepartment = Number(a); });
		setTimeout(() => {
			this.dialogRef.close({ 
				data: {
					requestDepartment: this.onGetDepartmentInfo(myDepartment),
					department : this.onGetDepartmentInfo(this.department), 
					division : this.onGetDivisionInfo()
				}
			});
		}, 0);
	}

	// Lấy thông tin phòng ban sử dụng
	onLoadDepartment() {
		this._dynamicSequence.Get_CoCauToChuc().subscribe(res => {
			if (res && res.data && res.data.length > 0) {
				this.originalDepartment = res.data[0];
				this.optionDepartment = res.data[0] ? this.onBuildDepartmentTreeView(res.data[0], []) : [];
				this.ftrUsingDepartment.next([...this.optionDepartment]);
				this.onChangeDetectView();
			}
		});
	}

	onGetDepartmentInfo(id) {
		if (!this.optionDepartment) return null;
		const departmentInfo = this.optionDepartment.find(d => d.Id_PB == id);
		return departmentInfo || null;
	}

	onGetDivisionInfo() {
		if (!this.optionsDivision) return null;
		const divisionInfo = this.optionsDivision.find(d => d.Id_PB == this.division);
		return divisionInfo || null;
	}

	// Xây dựng lại phòng ban theo dạng cây
	onBuildDepartmentTreeView(_data, _treeView: any[], _level: number = 0) {
		if (!_data) return;

		if (_data) {
			if (_level > 0) {
				_treeView.push({ Id_PB: _data["Id_PB"], TenPB: _data["TenPB"] });
			}

			if (_data.Childrens && _data.Childrens.length > 0) {
				_data.Childrens.forEach(child => {
					this.onBuildDepartmentTreeView(child, _treeView, _level + 1);
				})
			}
		}

		return _treeView;
	}

	onChangeDetectView() {
		if (!(this.changeDetectorRef as ViewRef).destroyed) {
			this.changeDetectorRef.detectChanges();
		}
	}

	onFilterUsingDepartment() {
		const search = this.usingDepartmentFtrCtrl;
		if (!this.optionDepartment) return;
		if (!search) {
			this.ftrUsingDepartment.next([...this.optionDepartment]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrUsingDepartment.next(
			this.optionDepartment.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.onChangeDetectView();
	}

	onFilterUsingDivision() {
		const search = this.usingDivisionFtrCtrl;
		if (!this.optionsDivision) return;
		if (!search) {
			this.ftrUsingDivision.next([...this.optionsDivision]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrUsingDivision.next(
			this.optionsDivision.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.onChangeDetectView();
	}

	// Hàm này được sử dụng để tải các tùy chọn phòng ban từ một giá trị nhất định
	onLoadDivisionOptions(value: string) {
		const selectedOptionDepartment = Number(value);
		let dropdownOptions: any[] = [];

		if (this.optionDepartment && Array.isArray(this.optionDepartment) && this.optionDepartment.length > 0) {
			dropdownOptions = this.onLoadOptionTreeDataFromIdParam(this.originalDepartment, dropdownOptions, selectedOptionDepartment);

			const hasSubData = dropdownOptions.length > 1;
			const subData = dropdownOptions.filter(option => option.Id_PB != selectedOptionDepartment);

			this.optionsDivision = hasSubData ? subData : dropdownOptions;
			this.ftrUsingDivision.next([...this.optionsDivision]);
			this.division = !hasSubData ? dropdownOptions[0].Id_PB + '' : '';
		}

		// Gọi hàm để cập nhật giao diện
		this.onChangeDetectView();
	}

	// Load tree from id node
	onLoadOptionTreeDataFromIdParam(data, ouput: any[], nodeID: number = 0) {
		if (!data) return;
		if (data) {
			var renewNodeId = false;
			if (data.Id_PB === nodeID) {
				ouput.push({
					Id_PB: data["Id_PB"],
					TenPB: data["TenPB"]
				});
				renewNodeId = true;
			}
			if (data.Childrens && data.Childrens.length > 0) {
				data.Childrens.forEach(child => {
					this.onLoadOptionTreeDataFromIdParam(child, ouput, renewNodeId ? child.Id_PB : nodeID);
				})
			}
		}
		return ouput;
	}
}
